import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getNews } from 'services/NewsService';

import { ApiStatus } from 'constants/enums';
import type { News } from 'models/news.interface';
import { handleApiErrors } from 'utils/errorUtils';

export interface NewsState {
  details: {
    data: News[];
    status: ApiStatus;
  }
}

const initialState: NewsState = {
  details: {
    data: [],
    status: ApiStatus.idle,
  }
};

export const fetchNews = createAsyncThunk(
  'news/fetchNews',
  async (_, thunkAPI) => {
    try {
      return await getNews();
    } catch (e) {
      handleApiErrors(e);
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    resetNewsState: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(fetchNews.pending, (state) => {
        state.details = {
          ...state.details,
          status: ApiStatus.loading,
        };
      })
      .addCase(fetchNews.fulfilled, (state, action) => {
        const clients = action.payload;

        state.details = {
          data: clients,
          status: ApiStatus.idle,
        };
      })
      .addCase(fetchNews.rejected, (state) => {
        state.details = {
          ...state.details,
          status: ApiStatus.idle,
        };
      });
  }
});

export const {
  resetNewsState,
} = newsSlice.actions;

export default newsSlice.reducer;
